module.exports = __webpack_public_path__ + "media/images/ui__infoBox--dark-97c2184da1e4e910feb18b2ab13f2c51.png";